import React from 'react';
import Avatar from './images/avatar.webp';
import parse from 'html-react-parser';
import { BiLoaderAlt } from 'react-icons/bi'; // Using a better loader icon

const InternalProfile: React.FC<{
  adminDetail: any;
  isAdminDetailLoading: boolean;
}> = ({ adminDetail, isAdminDetailLoading }) => {
  return (
    <div className="container-fluid p-4">
      {isAdminDetailLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <BiLoaderAlt className="spinner-border text-primary border-0" style={{ width: '3rem', height: '3rem' }} />
            <p className="mt-2 text-muted fw-medium">Loading Profile...</p>
          </div>
        </div>
      ) : (
        <div className="row g-5">
          {/* Left Column: Profile Card & Info */}
          <div className="col-lg-5 col-md-12 border-end-lg">
            <div className="d-flex flex-column align-items-center">
              {/* Image Section */}
              <div className="position-relative mb-4">
                <img
                  src={adminDetail?.image || Avatar}
                  alt="profileImg"
                  className="rounded-circle shadow-sm border border-4 border-white"
                  style={{
                    objectFit: 'cover',
                    height: '200px',
                    width: '200px'
                  }}
                />
              </div>

              {/* Name & Title Section */}
              <div className="text-center mb-4">
                <h3 className="fw-bold text-dark mb-1">
                  {`${adminDetail?.first_name || ''} ${adminDetail?.middle_name || ''} ${adminDetail?.last_name || ''}`}
                </h3>
                <span className="badge bg-soft-primary text-primary px-3 py-2 rounded-pill">
                  {adminDetail?.current_position || 'Internal Member'}
                </span>
              </div>

              {/* Contact Information List */}
              <div className="w-100 mt-2 px-xl-5">
                <div className="d-flex justify-content-between py-2 border-bottom">
                  <span className="text-muted small fw-bold text-uppercase">Email Address</span>
                  <span className="text-dark fw-medium">{adminDetail?.email || '--'}</span>
                </div>
                <div className="d-flex justify-content-between py-2 border-bottom">
                  <span className="text-muted small fw-bold text-uppercase">Phone Number</span>
                  <span className="text-dark fw-medium">{adminDetail?.mobile_number || '--'}</span>
                </div>
                <div className="d-flex justify-content-between py-2 border-bottom">
                  <span className="text-muted small fw-bold text-uppercase">Designation</span>
                  <span className="text-dark fw-medium">{adminDetail?.current_position || '--'}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Experience & Content */}
          <div className="col-lg-7 col-md-12">
            <div className="card border-0 bg-light rounded-4 shadow-none p-4">
              <div className="card-body">
                <div className="d-flex align-items-center mb-4">
                  <div className="bg-primary rounded-1 me-3" style={{ width: '5px', height: '30px' }}></div>
                  <h4 className="fw-bold mb-0">Professional Experience</h4>
                </div>
                
                <div className="text-secondary lh-lg fs-15">
                  {adminDetail?.experience ? (
                    parse(adminDetail.experience)
                  ) : (
                    <div className="alert alert-light border-dashed text-center py-4">
                      <p className="mb-0 text-muted italic">No professional experience data available.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Placeholder for future sections like Education */}
            {/* <div className="mt-4 px-4">
                <h5 className="fw-bold text-dark mb-3">Education</h5>
                <p className="text-muted">...</p>
            </div> */}
          </div>
        </div>
      )}

      <style>{`
        .bg-soft-primary { background-color: rgba(64, 81, 137, 0.1); }
        .border-dashed { border-style: dashed !important; }
        .fs-15 { font-size: 15px; }
        @media (min-width: 992px) {
          .border-end-lg { border-right: 1px solid #eff2f7 !important; }
        }
      `}</style>
    </div>
  );
};

export default InternalProfile;